import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7117085b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-group row" }
const _hoisted_3 = { class: "col-sm-4 col-form-label" }
const _hoisted_4 = { class: "col-sm-8" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "input-group-text badge-container" }
const _hoisted_7 = ["value", "field", "sourceInitial", "readonly", "onKeyup"]
const _hoisted_8 = {
  key: 0,
  class: "input-group-text rules-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-font" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "btn dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (items) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row mb-3",
          key: items.fieldName
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (field, itemIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col",
              key: itemIdx
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("label", _hoisted_3, _toDisplayString(field.friendlyFieldName), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass([`initial-badge-${field.selectedData.sourceInitial}`])
                      }, null, 2)
                    ]),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      value: field.selectedData.value,
                      field: field.fieldName,
                      sourceInitial: field.selectedData.sourceInitial,
                      readonly: _ctx.isReadOnly,
                      onKeyup: ($event: any) => (_ctx.typedValue(field.fieldId, field.fieldName, $event.target.value))
                    }, null, 40, _hoisted_7),
                    (field.selectedData.fieldRulesApplied)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (field.sourceData.length > 0)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_11, _hoisted_13))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.sourceData, (item, idx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "inline-block",
                          key: idx,
                          onClick: ($event: any) => (_ctx.selectValue(field.fieldId, field.fieldName, item))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([`initial-badge-${item.sourceInitial}`])
                          }, null, 2),
                          _createElementVNode("div", null, _toDisplayString(item.value), 1)
                        ], 8, _hoisted_15))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          }), 128)),
          (items.length !== this.columns)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.columnsRemainer, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col",
                  key: item
                }))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}